import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/inventoryTypes';

export const fetchDoctorsList = (reqData: any): Action<any> => {
  return updateAction(actionTypes.FETCH_DOCTORS_LIST, reqData);
};

export const saveDoctorsList = (reqData: any): Action<any> => {
  return updateAction(actionTypes.SAVE_DOCTORS_LIST, reqData);
};

export const fetchDoctorsImages = (reqData: any): Action<any> => {
  return updateAction(actionTypes.FETCH_DOCTORS_IMAGES, reqData);
};

export const fetchFileBytesData = (
  applicationId: any,
  fileIdentifiers: any,
  onSuccess: any,
): Action<any> => {
  return updateAction(actionTypes.FETCH_FILE_BYTES_DATA, {
    applicationId,
    fileIdentifiers,
    onSuccess,
  });
};

export const doctorsImages = (reqData: any): Action<any> => {
  return updateAction(actionTypes.DOCTORS_IMAGES, reqData);
};

export const setSelectedDoctorsList = (reqData: any): Action<any> => {
  return updateAction(actionTypes.SET_SELECTED_DOCTORS_LIST, reqData);
};

export const fetchIPInclusionMaster = (): Action<any> => {
  return updateAction(actionTypes.FETCH_IP_INCLUSION_MASTER);
};

export const fetchIPInclusionMasterData = (reqData: any): Action<any> => {
  return updateAction(actionTypes.IP_INCLUSION_MASTER_DATA, reqData);
};
export const fetchIPDepartmentMaster = (): Action<any> => {
  return updateAction(actionTypes.FETCH_IP_DEPARTMENT_MASTER);
};

export const fetchIPDepartmentMasterData = (reqData: any): Action<any> => {
  return updateAction(actionTypes.IP_DEPARTMENT_MASTER_DATA, reqData);
};
